/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestPagedList } from '../../models/export-request-paged-list';
import { SortDirection } from '../../models/sort-direction';

export interface SearchExportRequests$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the export request's name
 *   * CREATION_DATE : the export request's creation date
 *   * FREQUENCY : the export request's frequency
 *   * STATE : the export request's state
 */
  sortFieldName?: 'NAME' | 'CREATION_DATE' | 'FREQUENCY' | 'STATE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search export request
     */
    body?: any
}

export function searchExportRequests$Any(http: HttpClient, rootUrl: string, params?: SearchExportRequests$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchExportRequests$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportRequestPagedList>;
    })
  );
}

searchExportRequests$Any.PATH = '/export-request/search';
